// providers.js
/**
 * This file provides the Redux store to the React component tree using react-redux's Provider.
 * All components wrapped by <Providers> will have access to the Redux store.
 */

'use client';

import { Provider } from 'react-redux';
import { store } from '../shared/store';

// Providers component wraps children with Redux Provider
export function Providers({ children }) {
    return <Provider store={store}>{children}</Provider>;
}
